import {selectArrayTernary} from '@coolcolduk/util';
import {Box, Stack, TextField, Typography} from '@mui/material';
import {QuestionStatus} from '@cp/model';
import DropdownQuestionStatus from '../../atoms/dropdownQuestionStatus/DropdownQuestionStatus';

export interface QuestionEditStatusSectionProps {
  status: QuestionStatus;
  statusNote: string;
  flagLoading: boolean;
  hasQuestion: boolean;
  onStatusChange: (status: QuestionStatus) => void;
  onStatusNoteChange: (note: string) => void;
}

export default function QuestionEditStatusSection({
  status,
  statusNote,
  flagLoading,
  hasQuestion,
  onStatusChange,
  onStatusNoteChange,
}: QuestionEditStatusSectionProps) {
  return (
    <Box>
      <Typography variant="h6" sx={{color: '#1B263B', mb: 2}}>
        Question Status
      </Typography>
      <Stack spacing={2}>
        {/* <QuestionFormStatusDisplay status={status} statusNote={statusNote} /> */}

        <DropdownQuestionStatus
          status={status}
          onChange={(newStatus: QuestionStatus | null | undefined) => {
            if (newStatus) {
              onStatusChange(newStatus);
            }
          }}
          disabled={flagLoading || !hasQuestion}
        />

        <TextField
          label="Status Note"
          value={statusNote}
          onChange={(e) => onStatusNoteChange(e.target.value)}
          multiline
          rows={5}
          fullWidth
          placeholder="Enter a note about the question status..."
          disabled={!hasQuestion}
        />

        <Typography variant="body2" color="text.secondary">
          {selectArrayTernary(
            [status === QuestionStatus.FLAGGED, status === QuestionStatus.REVIEWED, status === QuestionStatus.CHECKED],
            [
              'This question is flagged as having a possible error',
              'This question has been reviewed and approved',
              'This question has been checked for accuracy',
            ],
            'This question was generated and is pending review',
          )}
        </Typography>
      </Stack>
    </Box>
  );
}
